<template>
  <section class="milestone">
    <img class="milestone-logo" src="~@/views/act/halloween/assets/img/milestone-logo.png" alt="milestoneLogo">
    <div class="milestone-title">
      <img :class="locale" class="milestone-title-img" :src="milestoneTitle" alt="milestoneTitle">
    </div>
    <div class="milestone-list">
      <div class="milestone-list-item" :class="statusClass(item.status)" v-for="item in milestones" :key="item.rewardCode">
        <div class="item-icon-wrap">
          <img :src="`${PUBLIC_PATH}imgs/props/${item.rewardItems[0].propId}.png`" alt="itemIcon">
        </div>
        <div class="item-text">
          {{ rewardText(item.rewardItems) }}
        </div>
        <button
          type="button"
          class="item-btn"
          :class="statusClass(item.status) + ' ' + locale"
          @click="emit('receive', item)"
        >
          {{ statusText(item.status) }}
        </button>
      </div>
      <div class="progress">
        <div class="progress-item" v-for="item in milestones" :key="item.rewardCode" :class="statusClass(item.status)">
          <div class="icon"></div>
          <div class="progress-text">
            {{ item.targetCount }}<br>{{ t('halloween.times') }}
          </div>
        </div>
        <img v-if="props.activityInfo?.totalStrikeCount" :class="progressCurrentClass" class="progress-current" src="~@/views/act/halloween/assets/img/dagou.png" alt="icon">
      </div>
    </div>
  </section>
</template>

<script setup>
import { defineProps, defineEmits, computed } from 'vue'
import { useI18n } from 'vue-i18n'
import MilestoneTitleMap from '@/views/act/halloween/assets/img/milestoneTitle/index.js'
const PUBLIC_PATH = process.env.VUE_APP_PUBLIC_PATH

const props = defineProps({
  milestones: {
    type: Array,
    default: () => [],
  },
  canPlay: {
    type: Boolean,
    default: false,
  },
  activityInfo: {
    type: Object,
    default: () => {},
  },
})

const emit = defineEmits(['receive'])
const { t, te, locale } = useI18n()

const milestoneTitle = computed(() => {
  return MilestoneTitleMap[locale.value]
})

const propName = (propId) => {
  const key = `halloween.props.${propId}`
  return te(key) ? t(key) : propId
}

const rewardText = (items) => {
  if (!items?.length) return ''
  return items
    .map((item) => {
      const name = propName(item.propId)
      return `${name} * ${item.propCount || 1}`
    })
    .join('、')
}

const statusText = (status) => {
  if (Number(status) === 2) return t('halloween.received')
  if (Number(status) === 1) return t('halloween.receive')
  return t('halloween.notReady')
}

const statusClass = (status) => {
  if (Number(status) === 2) return 'received'
  if (Number(status) === 1) return 'can-receive'
  return 'not-achieved'
}

const progressCurrentClass = computed(() => {
  // const totalStrikeCount = props.activityInfo?.totalStrikeCount || 0
  const totalStrikeCount = 5
  if (!totalStrikeCount) return ''
  if (totalStrikeCount >= 1 && totalStrikeCount < 10) return 'progress-current-1'
  if (totalStrikeCount < 20) return 'progress-current-2'
  if (totalStrikeCount < 30) return 'progress-current-3'
  if (totalStrikeCount < 40) return 'progress-current-4'
  if (totalStrikeCount < 50) return 'progress-current-5'
  if (totalStrikeCount < 60) return 'progress-current-6'
  if (totalStrikeCount < 70) return 'progress-current-7'
  if (totalStrikeCount < 80) return 'progress-current-8'
  if (totalStrikeCount < 90) return 'progress-current-9'
  if (totalStrikeCount < 100) return 'progress-current-10'
  return ''
})
</script>

<style lang="less" scoped>
.milestone {
  margin-top: 120px;
  position: relative;
  // .milestone-head-icon {
  //   width: 750px;
  //   height: 276px;
  //   position: absolute;
  //   z-index: 1;
  //   top: -220px;
  //   left: 50%;
  //   transform: translateX(-50%);
  // }
  .milestone-logo {
    width: 92px;
    height: 92px;
    position: absolute;
    z-index: 2;
    top: -10px;
    right: 25px;
  }
  .milestone-title {
    position: relative;
    z-index: 4;
    width: 712px;
    height: 232px;
    margin: 0 auto;
    background: url('~@/views/act/halloween/assets/img/milestone-title-bg.png') no-repeat center center / 100% 100%;
    position: relative;
    .milestone-title-img {
      height: 120px;
      position: absolute;
      left: 50%;
      transform: translateX(-50%);
      bottom: 37px;
      &.hk, &.tw {
        height: 73px;
        bottom: 60px;
      }
      &.th {
        height: 127px;
      }
      &.vi {
        height: 138px;
      }
      &.en, &.sg, &.my, &.ph, &.id {

      }
      
    }
  }
}

.milestone-list {
  position: relative;
  z-index: 3;
  padding: 60px 36px 50px 145px; 
  display: flex;
  flex-direction: column;
  gap: 8px;

  width: 732px;
  height: 1336px;
  background: url('~@/views/act/halloween/assets/img/milestone-bg.png') no-repeat center center / 100% 100%;
  margin-left: auto;
  margin-top: -60px;

  &::before {
    content: '';
    display: block;
    position: absolute;
    z-index: 1;
    left: 50%;
    transform: translateX(-50%);
    top: 36px;
    width: 659px;
    height: 1248px;
    background: url('~@/views/act/halloween/assets/img/milestone-inner-bg.png') no-repeat center center / 100% 100%;
  }

  .milestone-list-item {
    position: relative;
    z-index: 2;
    width: 534px;
    height: 104px;
    background: linear-gradient(to right, #BC52F8 0%, #E27CCB 50%, #E57ACC 100%);
    display: flex;
    align-items: center;
    &::before {
      content: '';
      display: block;
      width: 16px;
      height: 16px;
      background: #EEFF7D;
      clip-path: polygon(0 0, 100% 0, 0 100%);
      position: absolute;
      left: 0;
      top: 0;
    }
    .item-icon-wrap {
      width: 84px;
      height: 84px;
      border: 3px solid #FFFF8C;
      border-radius: 50%;
      background: #FDDF4D;
      display: flex;
      align-items: center;
      justify-content: center;
      margin: 0 40px;
      img {
        width: 70px;
        height: 70px;
      }
    }
    .item-text {
      height: 100%;
      display: flex;
      align-items: center;
      justify-content: center;
      flex: 1;
      font-size: 16px;
      color: #FFFFFF;
      text-align: center;
      border-right: 1px dashed #FFFFFF;
      padding: 0 5px;
      
    }
    .item-btn {
      min-width: 120px;
      height: 45px;
      border: 2px solid #8C8C8C;
      background: #9B9B9B;
      font-size: 18px;
      margin: 0 5px 0 20px;
      &.en, &.sg, &.my, &.ph, &.id {
        width: 170px;
        margin: 0 5px 0 10px;
      }
      &.can-receive {
        background: #FDEA5D;
        border-color: #FDEA5D;
        color: #1853D7;
      }
      &.not-achieved {
        background: #9B9B9B;
        border-color: #8C8C8C;
      }
    }
    &.not-achieved {
      background: linear-gradient(to right, #8F8E95 0%, #838383 50%, #646464 100%);
      &::before {
        background: #EEFFFF;
      }
    }
    &.can-receive {
      background: linear-gradient(to right, #FFFF1C 0%, #CF6EDF 50%, #C554FF 100%);
      &::before {
        background: #FFFFFF;
      }
    }
  }

  .progress {
    width: 20px;
    height: 1140px;
    border-radius: 10px;
    background: linear-gradient(to bottom, #EEBE2A 0%, #DE01FF);
    position: absolute;
    left: 45px;
    top: 100px;
    z-index: 3;
    .progress-current {
      width: 60px;
      height: 60px;
      position: absolute;
      left: 50%;
      // transform: translateX(-50%);
      margin-left: -30px;
      transform: translateY(-15px);
      top: 0;
      &.progress-current-1 { top: 0; }
      &.progress-current-2 { top: 111.8px; }
      &.progress-current-3 { top: 223.6px; }
      &.progress-current-4 { top: 335.4px; }
      &.progress-current-5 { top: 447.2px; }
      &.progress-current-6 { top: 559px; }
      &.progress-current-7 { top: 670.8px; }
      &.progress-current-8 { top: 782.6px; }
      &.progress-current-9 { top: 894.4px; }
      &.progress-current-10 { top: 1006.2px; }
      &.progress-current-11 { top: 1118px; }
    }
    .progress-item {
      width: 100%;
      height: 100%;
      position: absolute;
      top: 0;
      left: 0;

      .icon {
        width: 22px;
        height: 22px;
        border: 2px solid #fff;
        border-radius: 50%;
        position: absolute;
        left: 50%;
        margin-left: -11px;
      }
      .progress-text {
        position: absolute;
        width: 75px;
        font-size: 20px;
        text-align: center;
        left: 25px;
        transform: translateY(-15px);
        color: #FDF032;
      }
      &.not-achieved {
        .icon {
          border-color: #D8DAEF;
          background-color: #fff;
        }
        .progress-text {
          color: #B165F7;
        }
      }
      // 轨道 1140px，圆点 22px。11 个点，首个贴顶、末个贴底，间距 (1140 - 22) / 10 = 111.8px
      &:nth-child(1) { .icon { top: 0; } .progress-text { top: 0; } }
      &:nth-child(2) { .icon { top: 111.8px; } .progress-text { top: 111.8px; } }
      &:nth-child(3) { .icon { top: 223.6px; } .progress-text { top: 223.6px; } }
      &:nth-child(4) { .icon { top: 335.4px; } .progress-text { top: 335.4px; } }
      &:nth-child(5) { .icon { top: 447.2px; } .progress-text { top: 447.2px; } }
      &:nth-child(6) { .icon { top: 559px; } .progress-text { top: 559px; } }
      &:nth-child(7) { .icon { top: 670.8px; } .progress-text { top: 670.8px; } }
      &:nth-child(8) { .icon { top: 782.6px; } .progress-text { top: 782.6px; } }
      &:nth-child(9) { .icon { top: 894.4px; } .progress-text { top: 894.4px; } }
      &:nth-child(10) { .icon { top: 1006.2px; } .progress-text { top: 1006.2px; } }
      &:nth-child(11) { .icon { top: 1118px; } .progress-text { top: 1118px; } }
    }
  }
}

.milestone-btn {
  border: 0;
  border-radius: 8px;
  padding: 16px 24px;
  background: #ff8a2a;
  color: #1b1028;
  font-size: 28px;
  cursor: pointer;

  &:disabled {
    cursor: not-allowed;
    opacity: 0.45;
  }
}
</style>
